module.exports = __webpack_public_path__ + "img/zcpd.png";